import { useContext } from 'react';
import { createSelector } from 'reselect';
import { FeedStateContext, TradingblockWebsocketState } from './FeedState';

const getFeedStatus = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.status,
  status => status
);
export const useFeedStatus = () => {
  const state = useContext(FeedStateContext);
  return getFeedStatus(state);
};

const getNewsFeedStatus = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.newsStatus,
  status => status
);
export const useNewsFeedStatus = () => {
  const state = useContext(FeedStateContext);
  return getNewsFeedStatus(state);
};

const getWebSocketCloseReason = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.webSocketCloseReason,
  closeReason => closeReason
);
export const useWebSocketCloseReason = () => {
  const state = useContext(FeedStateContext);
  return getWebSocketCloseReason(state);
};

const getNewsWebSocketCloseReason = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.newsWebSocketCloseReason,
  closeReason => closeReason
);
export const useNewsWebSocketCloseReason = () => {
  const state = useContext(FeedStateContext);
  return getNewsWebSocketCloseReason(state);
};

const getFeedQuoteQueue = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.quoteQueue,
  quotes => quotes
);
export const useFeedQuoteQueue = () => {
  const state = useContext(FeedStateContext);
  return getFeedQuoteQueue(state);
};

const getFeedSpreadQueue = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.spreadQueue,
  spreads => spreads
);
export const useFeedSpreadQueue = () => {
  const state = useContext(FeedStateContext);
  return getFeedSpreadQueue(state);
};

const getLatestCashieringUpdateData = createSelector(
  (state: TradingblockWebsocketState) => state.cashieringUpdates.latestUpdateData,
  latestCashieringUpdateData => latestCashieringUpdateData
);

export const useLatestCashieringUpdateFeedData = () => {
  const state = useContext(FeedStateContext);

  return getLatestCashieringUpdateData(state);
};

const getNewsSubcriptions = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.newsSubscriptions,
  newsSubscriptions => newsSubscriptions
);
export const useNewsSubcriptions = () => {
  const state = useContext(FeedStateContext);
  return getNewsSubcriptions(state);
};
